import { render, staticRenderFns } from "./SaleLeadTable.vue?vue&type=template&id=2fa41645"
import script from "./SaleLeadTable.vue?vue&type=script&lang=js"
export * from "./SaleLeadTable.vue?vue&type=script&lang=js"
import style0 from "./SaleLeadTable.vue?vue&type=style&index=0&id=2fa41645&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports